<template>
  <v-main>
    <v-container class='o-container'>
      <v-row>
        <v-col cols='12'>
          <v-card flat>
            <v-card-title>
              <v-chip small color='primary'>宗旨</v-chip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p>
                瞬息萬變的市場中，該如何提升服務品質，才能有所突破？中華服務品質發展協會與您共同分享如何提升企業競爭力！不論您是主管、員工或社會新鮮人，衷心期盼您的加入，共同為建置及推展國內服務品質全方位資訊分享與專業學習平台而努力！
              </p>
              <p>
                中華服務品質發展協會為依法設立、非以營利為目的之社會團體，以協力發展提升顧客服務品質、顧客滿意度，進而掌握顧客脈動，創造最大績效與提升競爭優勢為宗旨。
              </p>
            </v-card-text>
          </v-card>

          <v-card flat>
            <v-card-title>
              <v-chip small color='primary'>沿革</v-chip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <ul>
                <li>民國99年5月28日立案</li>
                <li>民國99年9月27日完成登記</li>
              </ul>
            </v-card-text>
          </v-card>

          <v-card flat>
            <v-card-title>
              <v-chip small color='primary'>任務</v-chip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p>
                <ol>
                  <li v-for="(el, idx) in q" :key="idx">
                    {{ el }}
                  </li>
                </ol>
              </p>
            </v-card-text>
          </v-card>

          <v-card flat>
            <v-card-title>
              <v-chip small color='primary'>願景</v-chip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p>
                中華服務品質發展協會期望結合國內產、官、學三大領域之專業人才，共同建置一個服務品質全方位的資訊分享與專業學習平台，成為國內最具公信力與指標性之客觀服務品質評鑑單位。
              </p>
            </v-card-text>
          </v-card>

          <v-card flat>
            <v-card-title>
              <v-chip small color='primary'>架構</v-chip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p>
                <v-img
                  max-width="513"
                  max-height="374"
                  contain
                  :src="require('@/assets/img/group.png')"
                ></v-img>
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data: () => ({
    q: [
      '蒐集、建置並提供充分顧客服務相關之資訊。',
      '建構本會會員至各企業與機關組織之實習制度與媒介平台。',
      '建置服務品質能力評鑑機制。',
      '推動辦理相關教育訓練及專業證照之輔導。',
      '建立各級學校、學術研究機構與企業之橋樑，推動與辦理合作發展專案。',
      '協助發展顧客服務領域之人力供需媒合平台。',
      '協助辦理顧客服務類公益活動及社會福利事項。',
      '協助或接受各級政府單位專案交議或委託研辦事項。',
      '提供相關事業發展、諮詢與輔導。',
      '推動國際服務品質接軌活動。'
    ]
  })
}
</script>
